import script from "./PowerBIQueryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PowerBIQueryModal.vue?vue&type=script&setup=true&lang=js"

import "./PowerBIQueryModal.vue?vue&type=style&index=0&id=a890ca32&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a890ca32"]])

export default __exports__